import React, { useState } from "react";
import Decorativas from "../components/Products/Decorativas/Decorativas";
import ProductsNav from "../components/Products/ProductsNav/ProductsNav";
import { Box, Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles(({ breakpoints, spacing }) => ({
  backContainer: {
    margin: "0 2%",
  },
  background: {
    backgroundColor: "#EDF8F3",
    paddingTop: "1px",
  },
}));

const Products = (props) => {
  const classes = useStyles();

  return (
    <div className="content">
      <Container>
        <Box component="div" className={classes.backContainer}>
          <Container component="div" className={classes.background}>
            <Decorativas />
          </Container>
        </Box>
      </Container>
    </div>
  );
};

export default Products;
